var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Plus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 46,
    viewBox: "0 0 49 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 47,
    height: 44,
    rx: 7,
    stroke: "#004A8E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.148 33.28C16.86 33.28 15.74 33.0373 14.788 32.552C13.836 32.0667 13.0987 31.3853 12.576 30.508C12.072 29.612 11.82 28.576 11.82 27.4H14.844C14.844 28.4267 15.1333 29.2293 15.712 29.808C16.3093 30.3867 17.1307 30.676 18.176 30.676C19.24 30.676 20.0613 30.3773 20.64 29.78C21.2187 29.1827 21.508 28.3893 21.508 27.4V25.888C21.508 24.8427 21.2187 24.04 20.64 23.48C20.0613 22.9013 19.24 22.612 18.176 22.612H15.992V19.756L20.752 15.22H12.688V12.56H23.832V15.416L18.204 20.708V19.98C20.1453 19.98 21.6853 20.512 22.824 21.576C23.9627 22.64 24.532 24.068 24.532 25.86V27.4C24.532 28.576 24.2707 29.612 23.748 30.508C23.2253 31.3853 22.4787 32.0667 21.508 32.552C20.556 33.0373 19.436 33.28 18.148 33.28ZM31.9411 29.052L31.5771 28.856V24.208H27.6011V22.164L27.7971 21.8H31.5771V17.376H34.0131V21.8H37.9891V24.208H34.0131V29.052H31.9411Z",
    fill: "#004A8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Plus);
export default __webpack_public_path__ + "static/media/3plus.c16f12ef63c360ca3569d994948097de.svg";
export { ForwardRef as ReactComponent };